import React from 'react';
import { Check, Users, Smile, BookOpen } from 'lucide-react';
import { Button } from './ui/Button';
export function SolutionSection() {
  const scrollToPurchase = () => {
    const element = document.getElementById('comprar');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="bg-[#FDF6E3] py-16 px-4 sm:px-6 lg:px-8" data-id="element-303">
      <div className="max-w-5xl mx-auto" data-id="element-304">
        <h2 className="text-2xl md:text-3xl font-bold text-[#1e3a5a] text-center mb-10" data-id="element-305">
          Ahora imaginá esto ✨
        </h2>

        {/* Visual Transformation */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-12" data-id="element-306">
          {/* You */}
          <div className="bg-white p-6 rounded-xl shadow-sm border-l-4 border-[#1e3a5a] transform transition hover:shadow-lg" data-id="element-307">
            <div className="flex items-center gap-3 mb-4" data-id="element-308">
              <div className="bg-blue-100 p-2 rounded-full" data-id="element-309">
                <BookOpen className="w-5 h-5 text-[#1e3a5a]" data-id="element-310" />
              </div>
              <h3 className="font-bold text-[#1e3a5a]" data-id="element-311">Vos</h3>
            </div>
            <ul className="space-y-2 text-sm" data-id="element-312">
              <li className="flex items-center gap-2 text-gray-700" data-id="element-313">
                <Check className="w-4 h-4 text-green-500" data-id="element-314" /> Sabés qué dar
              </li>
              <li className="flex items-center gap-2 text-gray-700" data-id="element-315">
                <Check className="w-4 h-4 text-green-500" data-id="element-316" /> No improvisás
              </li>
              <li className="flex items-center gap-2 text-gray-700" data-id="element-317">
                <Check className="w-4 h-4 text-green-500" data-id="element-318" /> No te frustrás
              </li>
            </ul>
          </div>

          {/* Students */}
          <div className="bg-white p-6 rounded-xl shadow-sm border-l-4 border-[#d4a853] transform transition hover:shadow-lg md:-translate-y-2" data-id="element-319">
            <div className="flex items-center gap-3 mb-4" data-id="element-320">
              <div className="bg-yellow-100 p-2 rounded-full" data-id="element-321">
                <Users className="w-5 h-5 text-[#d4a853]" data-id="element-322" />
              </div>
              <h3 className="font-bold text-[#1e3a5a]" data-id="element-323">Los chicos</h3>
            </div>
            <ul className="space-y-2 text-sm" data-id="element-324">
              <li className="flex items-center gap-2 text-gray-700" data-id="element-325">
                <Check className="w-4 h-4 text-[#d4a853]" data-id="element-326" /> Entienden
              </li>
              <li className="flex items-center gap-2 text-gray-700" data-id="element-327">
                <Check className="w-4 h-4 text-[#d4a853]" data-id="element-328" /> Opinan y discuten
              </li>
              <li className="flex items-center gap-2 text-gray-700" data-id="element-329">
                <Check className="w-4 h-4 text-[#d4a853]" data-id="element-330" /> Participan
              </li>
            </ul>
          </div>

          {/* Result */}
          <div className="bg-white p-6 rounded-xl shadow-sm border-l-4 border-green-500 transform transition hover:shadow-lg" data-id="element-331">
            <div className="flex items-center gap-3 mb-4" data-id="element-332">
              <div className="bg-green-100 p-2 rounded-full" data-id="element-333">
                <Smile className="w-5 h-5 text-green-600" data-id="element-334" />
              </div>
              <h3 className="font-bold text-[#1e3a5a]" data-id="element-335">Resultado</h3>
            </div>
            <ul className="space-y-2 text-sm" data-id="element-336">
              <li className="flex items-center gap-2 text-gray-700" data-id="element-337">
                <Check className="w-4 h-4 text-green-500" data-id="element-338" /> La clase fluye
              </li>
              <li className="flex items-center gap-2 text-gray-700" data-id="element-339">
                <Check className="w-4 h-4 text-green-500" data-id="element-340" /> El aula responde
              </li>
              <li className="flex items-center gap-2 text-gray-700" data-id="element-341">
                <Check className="w-4 h-4 text-green-500" data-id="element-342" /> Salís tranquilo
              </li>
            </ul>
          </div>
        </div>

        {/* Product Showcase */}
        <div className="bg-[#1e3a5a] text-white p-8 rounded-2xl shadow-xl text-center" data-id="element-343">
          <p className="text-[#d4a853] font-semibold mb-2" data-id="element-344">
            La transformación que propone
          </p>
          <h2 className="text-2xl md:text-3xl font-extrabold text-white mb-4" data-id="element-345">
            POLÍTICA Y CIUDADANÍA 360
          </h2>
          <p className="text-blue-100 mb-6 text-sm" data-id="element-346">
            No es un PDF más. Es un{' '}
            <strong className="text-white" data-id="element-347">
              sistema de clases anuales listas
            </strong>
            , diseñado desde el aula real.
          </p>

          {/* Product Image */}
          <div className="max-w-sm mx-auto mb-6 cursor-pointer transform transition duration-300 hover:scale-105" onClick={scrollToPurchase} data-id="element-348">
            <img src="https://cdn.magicpatterns.com/uploads/3MdZ6pAmuJnbfB4t6UavwB/MOCKUP_PRINCIPAL_POLITICA_Y_CIUDADANIA.png" alt="Política y Ciudadanía 360" className="w-full rounded-xl shadow-2xl" data-id="element-349" />
          </div>

          <Button className="text-lg px-8 py-4" data-id="element-350">QUIERO ACCEDER AHORA</Button>
        </div>
      </div>
    </section>;
}